import { Box, Container, Theme, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef, useState } from "react";
import { Animated } from "react-animated-css";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Icon1 from '../../../assets/companyLogos/icon1.svg';
import Icon2 from '../../../assets/companyLogos/icon2.svg';
import Icon3 from '../../../assets/companyLogos/icon3.svg';
import Icon4 from '../../../assets/companyLogos/icon4.svg';
import Icon5 from '../../../assets/companyLogos/icon5.svg';

import NewIcon1 from '../../../assets/companyLogos/new/icon1.png';
import NewIcon2 from '../../../assets/companyLogos/new/icon2.png';
import NewIcon3 from '../../../assets/companyLogos/new/icon3.png';
import NewIcon4 from '../../../assets/companyLogos/new/icon4.png';
import NewIcon5 from '../../../assets/companyLogos/new/icon5.png';
import useOnScreen from "../../../hooks/useOnScreen";
import SectionTitle from "./SectionTitle";


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(19, 0),
        // backgroundColor: theme.palette.custom.textPrimary,
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(8, 0),
        },
       
       backgroundColor: `#fff`
    },
    logoArea: {
        paddingTop: theme.spacing(24),

        '& .slide': {
            display: 'flex !important',
            justifyContent: 'center',
            alignItems: 'center',
            '& img': {
                maxWidth: '6rem',
                height: '6rem'
            },
            [theme.breakpoints.down('md')]: {
                '& img': {
                    maxWidth: '3rem',
                    height: '3rem'
                }
            }
        },

        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(10),
        }

    }
}))

const TrustedBySection = () => {
    const classes = useStyles()
    const theme = useTheme()
    const ref = useRef(null)
    const onScreen = useOnScreen(ref, "-180px");
    const [sliderSettings] = useState<Settings>({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        arrows: false,
        responsive: [
            {
                breakpoint: theme.breakpoints.values.md,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    })

    return (
        <Box ref={ref} className={`${classes.root} section_white`} component='section' id='trustedBySection'>
            <Container>
                <Animated animationIn="fadeInUp" animationOut="fadeInUp" isVisible={onScreen} animateOnMount={false}>
                    <SectionTitle
                        headingTitle="Trusted by"
                        titleLine1="Proud"
                        titleLine2="Member of"
                        textWhite
                    // rotateTitleHeading
                    />
                </Animated>
                <Slider {...sliderSettings} className={classes.logoArea}>
                    {/* <Box className='slide'>
                        <img src={NewIcon5} alt='img1' />
                    </Box> */}
                    <Box className='slide'>
                        <img src={NewIcon1} alt='img1' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon2} alt='img2' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon3} alt='img3' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon4} alt='img4' />
                    </Box>
                    {/* <Box className='slide'>
                        <img src={Icon5} alt='img5' />
                    </Box> */}
                </Slider>
            </Container>
        </Box>
    )
}

export default TrustedBySection